import { Component, OnInit ,Input, EventEmitter, Output } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-report-desc-preview',
  templateUrl: './table-report-desc-preview.component.html',
  styleUrls: ['./table-report-desc-preview.component.scss']
})
export class TableReportDescPreviewComponent implements OnInit ,ViewCell{
  
  @Input() value : string | number;
  @Input() rowData : any;

  constructor() { }

  ngOnInit() {
  	//console.log(this.rowData);
  }

}
